import type { ComponentConfigV2, AssignmentOptions } from '@/types/configurationV2'

export default function AssignmentOptionsEditor({
  component,
  onUpdate,
}: { component: ComponentConfigV2; onUpdate: (u: ComponentConfigV2) => void }) {
  const options = component.options as AssignmentOptions
  return (
    <div>
      <div className="text-xs text-gray-500 mb-1">Diary Quiz Set ID</div>
      <input
        type="number"
        value={options.diaryQuizSetId ?? ''}
        onChange={(e) =>
          onUpdate({
            ...component,
            options: { ...options, diaryQuizSetId: e.target.value ? parseInt(e.target.value) : undefined },
          })
        }
        placeholder="(선택사항)"
        className="w-32 px-2 py-1 text-xs border border-gray-300 rounded"
      />
      <div className="text-xs text-gray-400 mt-1">정답 없는 Survey형 문제. 여러 레슨에 동일 문제 적용.</div>
    </div>
  )
}
